const _ = require('lodash');

const target = document.querySelectorAll('.first, .second');

function animeScroll() {
    target.forEach(function (element) {
        if (element.getBoundingClientRect().top >= 0 &&
            element.getBoundingClientRect().bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
            element.classList.add('animate');
        }
    })
}

animeScroll();

if (target.length) {
    window.addEventListener('scroll', _.debounce(function () {
        animeScroll();
    }, 200));
}
